import React from "react";
import {
  FaReact,
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaGitAlt,
  FaPhp,
} from "react-icons/fa";
import {
  SiTailwindcss,
  SiRedux,
  SiNodedotjs,
  SiC,
  SiCplusplus,
  SiMysql,
  SiStrapi,
  SiNextdotjs,
} from "react-icons/si";
import { DiDatabase } from "react-icons/di";

const Skills = () => {
  const skills = [
    { name: "HTML5", icon: <FaHtml5 />, color: "#e34c26" },
    { name: "CSS3", icon: <FaCss3Alt />, color: "#1572b6" },
    { name: "JavaScript", icon: <FaJs />, color: "#f7df1e" },
    { name: "React.js", icon: <FaReact />, color: "#61dafb" },
    { name: "Redux", icon: <SiRedux />, color: "#764abc" },
    { name: "Tailwind CSS", icon: <SiTailwindcss />, color: "#38b2ac" },
    { name: "Node.js", icon: <SiNodedotjs />, color: "#68a063" },
    { name: "Git", icon: <FaGitAlt />, color: "#f05033" },
    { name: "C", icon: <SiC />, color: "#00599c" },
    { name: "C++", icon: <SiCplusplus />, color: "#004482" },
    { name: "PHP", icon: <FaPhp />, color: "#777bb4" },
    { name: "SQL", icon: <DiDatabase />, color: "#f29111" },
    { name: "MySQL", icon: <SiMysql />, color: "#00758f" },
    { name: "Strapi CMS", icon: <SiStrapi />, color: "#4945ff" },
    { name: "Next.js", icon: <SiNextdotjs />, color: "#ffffff" },
  ];

  return (
    <div className=" py-12 px-6 rounded-xl shadow-lg">
      <h2 className="text-4xl font-bold text-[#e2e8f0] mb-12 text-center relative orbitron">
        Skills
        <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-gradient-to-r from-transparent via-[#94a3b8] to-transparent"></span>
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {skills.map((skill, index) => (
          <div
            key={index}
            className="flex flex-col items-center p-6 rounded-xl bg-[#0f172a] border border-[#334155] hover:border-[#64748b] transition-all duration-300 group hover:shadow-lg hover:-translate-y-1"
          >
            <div
              className="text-5xl mb-4 transition-all duration-300 group-hover:scale-110"
              style={{ color: skill.color }}
            >
              {skill.icon}
            </div>
            <p className="text-lg font-medium text-[#e2e8f0] philosopher-6">
              {skill.name}
            </p>
            <div
              className="w-8 h-1 mt-2 rounded-full transition-all duration-300 group-hover:w-12"
              style={{ backgroundColor: skill.color }}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;